import StatsSectionImplementation from '../implementation/sections/StatsSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiStatsSectionDTO,
  StatsSectionDTO,
} from '@lib/strapi/dtos/components/sections/statsSection.dto';

const StatsSection = (props: ComponentProps<StatsSectionDTO>) => {
  return <StatsSectionImplementation {...props}></StatsSectionImplementation>;
};

export default StatsSection;
